import type { LocaleOptions } from "primereact/api";

/** Locale do calendário do padrão (`variant` omitido). */
export const DATE_PICKER_LOCALE = "pt-br";
/**
 * Locale da variante `figma` (wizard Nova Obra, Figma `10413:103266`): dias "Dom Seg Ter Qua Qui Sex Sab" e
 * mês curto no cabeçalho ("Jul"). O padrão "pt-br" não muda.
 */
export const DATE_PICKER_LOCALE_FIGMA = "pt-br-figma";

/** Nomes de dia/mês e textos do calendário no pt-BR padrão: fonte única do locale global (`ds/locale`). */
export const CALENDAR_LOCALE_OPTIONS: LocaleOptions = {
  firstDayOfWeek: 0,
  dayNames: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
  dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
  monthNames: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ],
  monthNamesShort: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ],
  today: "Hoje",
  clear: "Limpar",
  weekHeader: "Sm",
  chooseDate: "Escolher a data",
};

/** O que a variante `figma` troca no pt-BR (dias e meses curtos). */
export const CALENDAR_LOCALE_FIGMA_OPTIONS: LocaleOptions = {
  firstDayOfWeek: 0,
  dayNames: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
  dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
  monthNames: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  monthNamesShort: [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ],
  today: "Hoje",
  clear: "Limpar",
  weekHeader: "Sm",
  chooseDate: "Escolher a data",
};

/** Locale padrão do `Calendar` (pt-BR). */
export const CALENDAR_LOCALE = DATE_PICKER_LOCALE;
